<script setup>
// NOTICE: KAPTION-INTEGRATION
// contact-first-conversation.FLAG.1 / BUTTON.1 — "Nuevo mensaje" in the
// chat-list header. Needs KAPTION_CONTACT_FIRST_CONVERSATION and
// KAPTION_REPLYBOX_TEMPLATE_PICKER (the empty conversation and closed windows
// are served by the "Plantilla" button), the whatsapp_templates permission and
// at least one WhatsApp inbox the agent can use. The template-first wizard
// stays reachable as "Avanzado" when KAPTION_NEW_CONVERSATION_MODAL is on.
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';
import NextButton from 'dashboard/components-next/button/Button.vue';
import { useKaptionFeatureFlags } from 'dashboard/composables/useKaptionFeatureFlags';
import { useFeaturePermissions } from 'dashboard/composables/useFeaturePermissions';
import KaptionNewConversationModal from 'dashboard/components-next/NewConversationModal/KaptionNewConversationModal.vue';
import KaptionContactFirstPalette from './KaptionContactFirstPalette.vue';
import {
  CONTACT_FIRST_FLAG,
  REPLY_TEMPLATE_FLAG,
} from './kaptionContactFirstHelpers';

const { t } = useI18n();
const { isKaptionFlagEnabled } = useKaptionFeatureFlags();
const { canUseFeature } = useFeaturePermissions();
const getWhatsAppInboxes = useMapGetter('inboxes/getWhatsAppInboxes');

// feature-permissions.REPLY_BOX.9 — admins can hide "Nuevo mensaje" per scope.
const isEnabled = computed(
  () =>
    canUseFeature('new_message') &&
    isKaptionFlagEnabled(CONTACT_FIRST_FLAG) &&
    isKaptionFlagEnabled(REPLY_TEMPLATE_FLAG) &&
    canUseFeature('whatsapp_templates') &&
    (getWhatsAppInboxes.value || []).length > 0
);
const canOpenAdvanced = computed(() =>
  isKaptionFlagEnabled('KAPTION_NEW_CONVERSATION_MODAL')
);

const showPalette = ref(false);
const showWizard = ref(false);

const openAdvanced = () => {
  showPalette.value = false;
  showWizard.value = true;
};
</script>

<template>
  <NextButton
    v-if="isEnabled"
    v-tooltip.bottom="t('KAPTION_CONTACT_FIRST.BUTTON')"
    data-testid="contact-first-button"
    icon="i-lucide-message-square-plus"
    teal
    xs
    :aria-label="t('KAPTION_CONTACT_FIRST.BUTTON')"
    @click="showPalette = true"
  />
  <KaptionContactFirstPalette
    v-if="isEnabled && showPalette"
    :can-open-advanced="canOpenAdvanced"
    @close="showPalette = false"
    @advanced="openAdvanced"
  />
  <Teleport to="body">
    <KaptionNewConversationModal
      v-if="isEnabled && canOpenAdvanced && showWizard"
      @close="showWizard = false"
    />
  </Teleport>
</template>
